import React from 'react';
import { connect } from "react-redux";
import { Route, Redirect } from 'react-router-dom';
import { fetchLogin, isAuthenticated, fetchUserPermissions, authenticateAccount } from '../../actions/AccountActions';
import Permissive from '../PermissiveWrapper/Permissive';
import { publicEnrollmentSessionService } from '../../utils/PublicEnrollmentSessionService';

class AuthWrapper extends React.Component {
    async componentDidMount() {

        // In the special case this is a "public" enrollment session, normal auth rules don't apply: skip this.
        if (publicEnrollmentSessionService.isPublicEnrollmentSessionActive() || publicEnrollmentSessionService.tryRestorePublicSession()) {
            // This is all confusing. This basically registers to _other_ components
            // that the user is authenticated. Whoever dreamed up this auth logic to begin with did a poor job,
            // this is very hard to follow.
            await this.props.authenticateAccount();
            return;
        }

        if(!this.props.account.isAuthenticated) {
            await this.props.authenticateAccount();
            this.props.fetchUserPermissions();
        }
    }

    isAuthenticated = () => {
        // In the special case this is a "public" enrollment session, normal auth rules don't apply: let them through,
        // do NOT prompt for login.
        if (publicEnrollmentSessionService.isPublicEnrollmentSessionActive() || publicEnrollmentSessionService.tryRestorePublicSession()) {
            return true;
        }

        if(!this.props.isAuthenticated() && !this.props.account.isLoggingOut) {
            this.props.login();
        } else {
            return true;
        }
    };
    
    render() {
        const { component: Component, render, account, ...rest } = { ...this.props };
        return (
            <Route {...rest} render={(props) => {
                return (
                    this.isAuthenticated()
                        ?
                        Component
                            ?
                            this.props.permissions
                                ?
                                <Permissive permissions={this.props.permissions}>
                                    <Component {...props} {...rest} />
                                </Permissive>
                                :
                                <Component {...props} {...rest} />
                            :
                            render
                                ?
                                (<Permissive permissions={this.props.permissions}>
                                    {render()}
                                </Permissive>)
                                :
                                <Redirect to="/" />
                        :

                        <Redirect to="/login" />
                );
            }} />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        login: () => {
            dispatch(fetchLogin());
        },
        authenticateAccount: () => {
            return dispatch(authenticateAccount());
        },
        fetchUserPermissions: () => {
            return dispatch(fetchUserPermissions());
        },
        isAuthenticated: () => {
            return isAuthenticated();
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapper);